module.exports = __webpack_public_path__ + "static/img/tt2.73959e56.png";